import { memo, useEffect, useState } from 'react';
import { Modal as UiModal } from '@upstox/upstox-ui';

const Modal = (props: ModalProps) => {
  let [root, setRoot] = useState(undefined);

  useEffect(() => {
    setRoot(window.document.getElementById('modalRoot'));
  }, [root]);

  return <UiModal zIndex={11} container={root} {...props} />;
};

export default memo(Modal);
